<template lang="html">
  <div class="track-goals-component">
    <div class="component-main">
      <div class="component-label">
        <h3>Track Your Goals</h3>
      </div>
      <div class="component-options">
        <ul class="list-inline">
          <li class="list-inline-item"><router-link :to="{ name: 'NewGoal' }">New Goal</router-link></li>
          <li class="list-inline-item"><a href="#">View All</a></li>
        </ul>
      </div>
    </div>
    <div class="component-charts">
      <carousel  :autoplay="false" :nav="false" :items="1">
        <div class="component-chart">
          <div class="component-chart-top">
            <div class="component-chart-label">
              Week Completion
            </div>
            <div class="component-chart-daterange">
              <div class="progress">
                <div class="progress-bar" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>
          </div>
          <div class="component-the-chart">
            <canvas id="myChart" width="400" height="300"></canvas>
          </div>
        </div>
        <div class="component-chart">
          <div class="component-chart">
            <div class="component-chart-top">
              <div class="component-chart-label">
                Category Breakdown
              </div>
              <div class="component-chart-daterange">

              </div>
            </div>
            <div class="component-the-chart">
              <canvas id="categoryChart" width="400" height="300"></canvas>
            </div>
          </div>
        </div>
      </carousel>
    </div>
    <div class="component-timeframe">
      <div class="component-timeframe-label">
        <p>This Week</p>
      </div>
      <div class="component-timeframe-right">
        <button type="button" class="btn btn-sm btn-secondary"><i class="fas fa-chevron-left"></i></button>
        <button type="button" class="btn btn-sm btn-secondary"><i class="fas fa-chevron-right"></i></button>
      </div>
      <div class="component-timeframe-left">
        <select class="form-control" name="">
          <option value="">All Categories</option>
          <option value="">Fitness</option>
          <option value="">Intellect</option>
        </select>
      </div>
    </div>
    <div v-for="goal in goals" class="component-goal">
      <div class="component-goal-main">
        <div class="component-label">
          <h4>{{ goal.title }}</h4>
          <p class="component-category">{{ goal.category }}</p>
        </div>
        <div class="component-options">
          <div class="dropdown">
            <button class="float-right btn-goal-options btn btn-sm" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="false" aria-expanded="false">
              <i class="fa fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" href="#">Edit</a>
              <a class="dropdown-item" href="#">Delete</a>
            </div>
          </div>
        </div>
      </div>
      <div class="component-goal-days">
        <div class="btn-group btn-group-justified" role="group">
          <button type="button" class="btn btn-sm btn-outline-secondary">MON</button>
          <button type="button" class="btn btn-sm btn-outline-secondary">TUE</button>
          <button type="button" class="btn btn-sm btn-outline-secondary">WED</button>
          <button type="button" class="btn btn-sm btn-outline-secondary">THUR</button>
          <button type="button" class="btn btn-sm btn-outline-secondary">FRI</button>
          <button type="button" class="btn btn-sm btn-outline-secondary">SAT</button>
          <button type="button" class="btn btn-sm btn-outline-secondary">SUN</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import { Radar, Line, mixins } from 'vue-chartjs'

export default {
  name: 'TrackGoals',
  props: ['user','goals'],
  components: { carousel },
  data() {
    return {
      chart: null,
    }
  },

  mounted() {
    this.drawDailyProgressChart()
    this.drawCategoryChart()
  },
  methods: {
    drawDailyProgressChart() {
      var ctx = document.getElementById("myChart").getContext('2d');
      var myChart = new Chart(ctx, {
          type: 'line',
          data: {
              labels: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday","Sunday"],
              datasets: [{
                  label: 'Goals Achieved',
                  data: [12, 19, 3, 5, 2, 3, 4],
                  backgroundColor: [
                      'rgba(255, 99, 132, 0.2)',
                      'rgba(54, 162, 235, 0.2)',
                      'rgba(255, 206, 86, 0.2)',
                      'rgba(75, 192, 192, 0.2)',
                      'rgba(153, 102, 255, 0.2)',
                      'rgba(255, 159, 64, 0.2)'
                  ],
                  borderColor: [
                      'rgba(255,99,132,1)',
                      'rgba(54, 162, 235, 1)',
                      'rgba(255, 206, 86, 1)',
                      'rgba(75, 192, 192, 1)',
                      'rgba(153, 102, 255, 1)',
                      'rgba(255, 159, 64, 1)'
                  ],
                  borderWidth: 1
              }]
          },
          options: {
            legend: {
              display: false,
            },
              scales: {
                  yAxes: [{
                      display: false,
                      ticks: {
                          beginAtZero:true
                      }
                  }],
                  xAxes: [{
                    display: false,
                  }]
              }
          }
      })
    },
    drawCategoryChart() {
      var ctx = document.getElementById("categoryChart").getContext('2d');
      var categoryChart = new Chart(ctx, {
          type: 'radar',
          data: {
            labels: ['Career', 'Diet', 'Finance', 'Fitness', 'Fun', 'Health', 'Intellect', 'Relationships', 'Spiritual', 'Travel'],
            datasets: [
              {
               label: 'Achieved',
               backgroundColor: 'rgba(0, 99, 132, 0.2)',
               borderColor: 'rgba(0, 99, 132, 1)',
               pointBackgroundColor: 'rgba(0, 99, 132, 0.2)',
               data: [2, 3, 5, 6, 8, 5, 7],
              },
              {
              label: 'Goal',
              backgroundColor: 'rgba(255,99,132,0.3)',
              borderColor: 'rgba(255,99,132,1)',
              pointBackgroundColor: 'rgba(255,99,132,0.3)',
              data: [12, 19, 3, 5, 2, 3, 4],
            }]
          },
          options: {
            legend: {
              display: false,
            },
              scales: {
                  yAxes: [{
                      display: false,
                      ticks: {
                          beginAtZero:true
                      }
                  }],
                  xAxes: [{
                    display: false,
                  }]
              }
          }
      })
    }
  }
}
</script>

<style scoped lang="css">

.track-goals-component {
  border: 2px solid #c9c9c9;
  border-radius: 5px;
}
.component-main {
  display: flex;
  background: #e9e9e9;
  padding: 11px 10px;
  border-bottom: 1px solid #c9c9c9;
}
.component-main .component-label {
  flex: 1;
}
.component-main .component-label h3 {
  font-size: 15px;
  font-weight: bold;
  margin: 0;
  padding: 0;
}
.component-main .component-options {
  flex: 1;
  text-align: right;
  font-size: 11px;
}
.component-main .component-options ul {
  margin: 0;
  padding: 0;
}
.component-main .component-options ul li:first-child:before {
  content: none;
}
.component-main .component-options ul li:before {
  content: '|';
  margin-right: 10px;
  color: #c9c9c9;
}

.component-chart {

}
.component-chart-top {
  display: flex;
  padding: 10px;
  font-size: 12px;
  font-weight: bold;
}
.component-chart-top .component-chart-label {
  flex: 1;
}
.component-chart-top .component-chart-daterange {
  flex: 1;
}
.component-the-chart {

}

.component-timeframe {
  display: flex;
  background: #f8f9fa;
  border-top: 1px solid #c9c9c9;
  border-bottom: 1px dotted #c9c9c9;
  padding: 4px 10px 2px 10px;
  align-items: center;
  justify-content: center;
}
.component-timeframe-label {
  flex: 2;
  text-align: left;
}
.component-timeframe-label p {
  font-size: 12px;
  margin: 0;
  padding: 0;
}
.component-timeframe-left {
  flex: 3;
  margin-bottom: 4px;
  text-align: left;
}
.component-timeframe-left select {
  font-size: 14px;
  height: 27px;
  margin: 3px 0 0 5px;
  padding: 0;
}
.component-timeframe-right {
  flex: 1;
  margin-bottom: 4px;
  text-align: right;
}
.component-timeframe-left button, .component-timeframe-right button {
  padding: 1px 7px;
  font-size: 10px;
}

.component-goal {
  border-bottom: 1px solid #c9c9c9;
  padding: 14px 10px;
}
.component-goal:last-child {
  border-bottom: none;
}
.component-goal .component-goal-main {
  display: flex;
  margin-bottom: 8px;
}
.component-goal .component-label h4 {
  margin: 0;
  padding: 0;
  flex: 8;
  font-size: 14px;
  font-weight: bold;
}
.component-goal .component-options {
  flex: 1;
  text-align: right;
}
.component-goal .component-options button {
  font-size: 10px;
  color: #999;
  padding: 1px 5px;
}
.component-goal-days {
  display: flex;
}
.component-goal-days .btn-group {
  flex: 1;
}
.component-goal-days .btn-group button {
  font-size: 12px;
  flex: 1;
  font-weight: bold;
  border-color: #c9c9c9;
  background: #f8f9fa;
  color: #999;
}

.component-category {
  margin: 5px 0 2px 0;
  font-size: 12px;
  font-style: italic;
}

</style>



// WEBPACK FOOTER //
// src/components/goals/components/TrackGoals.vue